// extracted by mini-css-extract-plugin
export default {"home":"c-i_cP","home__background":"c-i_cQ","home__content":"c-i_cR"};